import { make } from 'vuex-pathify'
import store from '../index'
import { getQueryFromFilter, showError, showSuccess } from '@/util/helpers'
import { formatDate } from '@/util/formatters'
import axios from 'axios'

const defaultResumo = () => ({
  produtosCadastrados: 0,
  produtosEstoqueBaixo: 0,
  produtosSemEstoque: 0,
  valorEstoque: 0,
})

const state = {
  product: {
    inventories: [],
  },

  products: {
    data: [],
    count: 0,
    limit: 50,
  },

  resumo: defaultResumo(),

  productStats: {
    data: {},
    loading: false,
    dialog: false,
  },

  cfops: {
    data: [],
    count: 0,
    limit: 50,
    loading: false,
  },

  ncms: {
    data: [],
    count: 0,
    limit: 50,
    loading: false,
  },

  filter: {
    page: 1,
    itemsPerPage: 25,
    sortBy: ['name'],
    sortDesc: [false],
  },

  dialog: false,
  type: 'add',
  loading: false,
}

const mutations = make.mutations(state)

const actions = {
  add: ({ state }) => {
    state.product = {
      inventories: [],

      active: true,
      companyId: store.get('authStore@currentCompany').id,
    }
    state.type = 'add'
    state.dialog = true
  },

  edit: ({ state }, id) => {
    state.loading = true
    store.dispatch('productStore/getById', id)
      .then(res => {
        state.product = res.data

        state.type = 'edit'
        state.dialog = true
      })
      .catch(showError)
      .finally(() => (state.loading = false))
  },

  view: ({ state }, id) => {
    state.loading = true
    store.dispatch('productStore/getById', id)
      .then(res => {
        state.product = res.data

        state.type = 'view'
        state.dialog = true
      })
      .catch(showError)
      .finally(() => (state.loading = false))
  },

  showProductStats: ({ state }, id) => {
    state.productStats.loading = true
    return axios
      .get(`${process.env.VUE_APP_API_URL}/product-stats/${id}`)
      .then(res => {
        state.productStats.data = res.data
        state.productStats.dialog = true

        // format data
        state.productStats.data.lastRequest = res.data.lastRequest
          ? formatDate(new Date(res.data.lastRequest).toISOString().substr(0, 10))
          : null
      })
      .catch(showError)
      .finally(() => (state.productStats.loading = false))
  },

  save: ({ state }, product) => {
    const id = product.id
    const method = id ? 'put' : 'post'

    state.loading = true
    const payload = { ...product }
    delete payload.imgUrl
    delete payload.imgPreview
    return axios[method](`${process.env.VUE_APP_API_URL}/product/${id || ''}`, payload)
      .then((res) => {
        state.dialog = false
        store.dispatch('productStore/get')
        showSuccess('Produto salvo com sucesso!')
      })
      .catch(showError)
      .finally(() => (state.loading = false))
  },

  get: async ({ state }, filter = state.filter) => {
    state.loading = true
    return axios.get(`${process.env.VUE_APP_API_URL}/product?${getQueryFromFilter(filter)}`)
      .then(res => {
        state.products = res.data
        state.resumo = res.data.resumo || defaultResumo()
        return res.data
      })
      .catch(showError)
      .finally(() => (state.loading = false))
  },

  getById: (context, id) => axios.get(`${process.env.VUE_APP_API_URL}/product/${id}`).catch(showError),

  getByProductCode: async ({ state }, data) => {
    state.loading = true
    return axios.get(`${process.env.VUE_APP_API_URL}/product?${getQueryFromFilter(data)}`)
      .then(res => res.data)
      .catch(showError)
      .finally(() => (state.loading = false))
  },

  getCfops: ({ state }, filter = {}) => {
    state.cfops.loading = true
    return axios.get(`${process.env.VUE_APP_API_URL}/cfops?${getQueryFromFilter(filter)}`)
      .then(res => {
        state.cfops = res.data
        return res.data
      })
      .catch(showError)
      .finally(() => (state.cfops.loading = false))
  },

  getNcms: ({ state }, filter = {}) => {
    state.ncms.loading = true
    return axios.get(`${process.env.VUE_APP_API_URL}/ncms?${getQueryFromFilter(filter)}`)
      .then(res => {
        state.ncms = res.data
        return res.data
      })
      .catch(showError)
      .finally(() => (state.ncms.loading = false))
  },

  reloadPrices: (context) => {
    state.loading = true
    return axios.post(`${process.env.VUE_APP_API_URL}/reload-prices`)
      .then(_ => {
        store.dispatch('productStore/get')
        showSuccess('Preços dos produtos recalculados com sucesso!')
      })
      .catch(showError)
      .finally(() => (state.loading = false))
  },

  remove: ({ state }, id) => {
    state.loading = true
    return axios.delete(`${process.env.VUE_APP_API_URL}/product/${id}`)
      .then(_ => {
        store.dispatch('productStore/get')
        showSuccess('Produto excluído com sucesso!')
      })
      .catch(showError)
      .finally(() => (state.loading = false))
  },
}

const getters = make.getters(state)

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
